/* eslint-disable @typescript-eslint/no-unsafe-return */
import { cacheHalfFullApi } from '@src/libs/cacheHalfFull'
import { IConfigResponse } from '@src/types/config.api'

export const apiGetConfig = async (): Promise<IConfigResponse> => {
    const { data } = await cacheHalfFullApi.get<IConfigResponse>('/get_config')
    return data
}
